<template>
  <div class="lock-icon">
    <b-img :src="state ? require('../../../../../assets/image/ic_lock_off.png') :
      require('../../../../../assets/image/ic_lock.png') " @click="chg_lock"/>
    <b-modal
      content-class="md_modal_content"
      :title="$t('admin.lock_unlock_setting')"
      id="modal"
      :hide-footer="true"
      header-class="mo-header"
    >
      <b-input class="margin-bottom-15" v-model="pass" :placeholder="$t('admin.password')" type="text" style="text-align: center"></b-input>
      <b-button
        style="width: 100%"
        @click="apply"
        variant="primary">{{$t('admin.lock_unlock_apply')}}</b-button>

      <template slot="modal-header-close">
        <p class="h1"><b-icon icon="x"></b-icon></p>
      </template>
    </b-modal>
  </div>
</template>
<script>
import utils from "../../../../../config/utils";
export default {
  name: 'Lock',
    data() {
      return {
        pass:null,
        state: this.$store.getters.adminLock,
      }
    },
    methods: {
    chg_lock(){
      this.$bvModal.show('modal');
    },
      apply(){
      if(this.pass === "1041"){
        this.state = !this.state;
        this.$store.commit('setAdmLock',this.state);
        this.$bvModal.hide('modal');
        this.pass = null;
        this.$emit('click', this.state);
      }else{
        utils.toast(this, this.$t('admin.password_not_matched'));
      }
      }
    },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/controls/lock.vue